// extracted by mini-css-extract-plugin
export default {"container":"catalog-page_container__5yWtS"};